import { useState, useCallback } from 'react';

import { ListItem } from 'common/types/common';

export type MultipleSelectState = ListItem[];
export type ChangeMultipleSelectState = (event: any, value: any[]) => void;
export type SetMultipleSelectState = (value: MultipleSelectState) => void;

export const useMultipleSelectState = (initValue: MultipleSelectState) => {
  const [value, setValue] = useState<MultipleSelectState>(() => (initValue || []));

  const changeValue: ChangeMultipleSelectState = useCallback((_, value) => {
    setValue(value || []);
  }, [setValue]);

  return [value, changeValue, setValue] as const;
};
